import React, { useState, useEffect } from "react";
import "./Report.css";
import Main from "../../common/Main/Main";
import Loadspinner from "../../common/Loadspinner";
import DynamicGrid from "../../ReusableComponents/DynamicGrid/DynamicGrid";
import moment from "moment";
import notify from "../../ReusableComponents/ToastNotification/ToastNotification";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import InputForm from "../../ReusableComponents/InputForm/InputForm";
import SelectForm from "../../ReusableComponents/SelectForm/SelectForm";
import * as urls from "../../helpers/API/APIEndPoints";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Typography, TextField, Tooltip } from "@mui/material";
import { debounceSearchRender } from "mui-datatables";
import { APICall } from "../../helpers/API/APICalls";
import fileDownload from "js-file-download";
import { useHistory } from "react-router-dom";
import { OverflowTip } from "../../ReusableComponents/OverFlowTip/OverflowTip";
import { Button } from "react-bootstrap";
import ResetButton from "../../ReusableComponents/Buttons/ResetButton/ResetButton";
import SubmitButton from "../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import CreateKnowledgeService from "../../services/CreateKnowledgeService";
import CommonServices from "../../services/CommonService";

const Report = () => {
  const [loading, setLoading] = useState(false);

  const [coeOptions, setCoeOptions] = useState([]);
  const [aggregateOptions, setAggregateOptions] = useState([]);
  const [platformOptions, setPlatformOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedCoe, setSelectedCoe] = useState([]);
  const [selectedAggregate, setSelectedAggregate] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [fromDate, setFromDate] = useState(
    CommonServices.getCurrentMonthStart(),
  );
  const [toDate, setToDate] = useState(CommonServices.getCurrentMonthEnd());
  const [keywords, setKeywords] = useState("");
  const [selectedUser, setSelectedUser] = useState([]);

  const [dashboardData, setDashboardData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [reset, setReset] = useState(false);
  const fileExtension = ".xlsx";

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    // customSearchRender: debounceSearchRender(500),
    responsive: "standard",
    onChangeRowsPerPage: () => {
      // num
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    // onSearchChange: (searchText) => {
    //   if (searchText !== null) {
    //     setSearchText(searchText);
    //   } else {
    //     setSearchText("");
    //   }=
    // },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  useEffect(() => {
    getDashboardData(false);
  }, [start, sortColumn, sortDirection, reset]);

  const getDashboardData = async (isExport) => {
    setLoading(true);
    let reqFilterObj = {
      start: isExport ? 0 : start,
      resultsPerPage: isExport ? count : pageSize,
      sortColumn,
      sortDirection,
      coe:
        selectedCoe && selectedCoe.length > 0
          ? selectedCoe.map(({ value }) => value).toString()
          : "",
      aggregate:
        selectedAggregate && selectedAggregate.length > 0
          ? selectedAggregate.map(({ value }) => value).toString()
          : "",
      platform:
        selectedPlatform && selectedPlatform.length > 0
          ? selectedPlatform.map(({ value }) => value).toString()
          : "",
      status:
        selectedStatus && selectedStatus.length > 0
          ? selectedStatus.map(({ value }) => value).toString()
          : "",
      fromDate:
        fromDate === null || fromDate === ""
          ? null
          : moment(fromDate).format("YYYY-MM-DD"),
      toDate:
        toDate === null || toDate === ""
          ? null
          : moment(toDate).format("YYYY-MM-DD"),
      keywords: keywords,
      user:
        selectedUser && selectedUser.length > 0
          ? selectedUser.map(({ value }) => value).toString()
          : "",
      isExport: isExport,
      userId: "", //UserId
    };
    let res = await APICall(urls.getReportData, reqFilterObj, "POST");
    if (isExport) {
      if (
        res.data !== null &&
        res.message.toLowerCase() == "ok" &&
        res.data.type === "Buffer"
      ) {
        let byteArray = new Uint8Array(res.data.data);
        fileDownload(
          byteArray,
          `Report ` +
            `${moment(new Date()).format("DD MMM YYYY")}${fileExtension}`,
        ); //add time stamp
      } else {
        notify(1, "Export Failed.");
      }
    } else {
      if (
        res.data !== null &&
        res.message.toLowerCase() == "ok" &&
        res.data.length > 0
      ) {
        for (let index = 0; index < res?.data?.length; index++) {
          const rs = res?.data?.[index];

          if (
            rs?.attachment_file_type?.toLowerCase()?.startsWith("video") &&
            rs?.video_id
          ) {
            let vtoken = await CreateKnowledgeService.getVideoToken(
              rs?.video_id,
            );
            let videoDownloadUrl =
              await CreateKnowledgeService.getVideoDownloadUrl(
                rs?.video_id,
                vtoken,
              );
            rs.attachment = videoDownloadUrl;
          }

          if (rs?.VideoExtension) {
            if (rs?.VideoExtension.includes("video")) {
              rs.attachment = rs?.VideoUrl;
            }
          }
        }
        debugger;
        setDashboardData(res.data);
        setCount(res.totalCount);
      } else {
        setDashboardData([]);
        setCount(0);
      }
    }
    setLoading(false);
  };

  const exportToExcelFunction = async () => {
    getDashboardData(true);
  };

  const dashboardColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: false,
      },
    },
    {
      name: "id",
      label: "Knowledge/Query Id",
      options: {
        display: true,
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "creator",
      label: "User",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "coe",
      label: "CoE",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "aggregate",
      label: "Aggregate",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "platform",
      label: "Platform",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "title",
      label: "Knowledge Title",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "description",
      label: "Knowledge Description",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value) => {
          return (
            <OverflowTip>
              <span>{value}</span>
            </OverflowTip>
          );
        },
      },
    },

    {
      name: "attachment",
      label: "Knowledge Document",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        setCellProps: () => ({
          style: { minWidth: "150px", maxWidth: "150px" },
        }),
        customBodyRender: (value) => {
          return (
            <OverflowTip>
              <a
                className="link-primary"
                href={value}
                target="_blank"
                rel="noopener noreferrer"
              >
                {value ? "Download" : ""}
              </a>
            </OverflowTip>
          );
        },
      },
    },

    {
      name: "taggedPeople",
      label: "Tagged People",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "hastags",
      label: "Hastags",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "Location",
      label: "Location",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "status",
      label: "Request Status",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "verificationStatus",
      label: "Verification Status",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "Keywords",
      label: "Keywords",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    // {
    //   name: "created_date",
    //   label: "Created Date",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     customBodyRender: (value) => {
    //       let dateObj = moment(value);
    //       let dateStr = dateObj.isValid() ? dateObj.format("DD-MMM-yyyy") : "";
    //       return (
    //         <>
    //           <Typography component={"span"} noWrap={true}>
    //             {dateStr}
    //           </Typography>
    //         </>
    //       );
    //     },
    //   },
    // },
    // {
    //   name: "statusId",
    //   label: "Action",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     setCellProps: () => ({
    //       style: { textAlign: "center" },
    //     }),
    //     setCellHeaderProps: () => ({
    //       style: { textAlign: "center" },
    //     }),
    //     customBodyRender: (value, tableMeta) => {
    //       let id = tableMeta.tableData[tableMeta.rowIndex].id;
    //       return (
    //         <div className="d-flex gap-2">
    //           <Tooltip
    //             title={
    //               (isAdmin === "false" && value == 3) ||
    //               (isAdmin === "true" && value == 2)
    //                 ? "edit"
    //                 : "view"
    //             }>
    //             <p className="ml-3">
    //               <a
    //                 style={{ cursor: "pointer" }}
    //                 onClick={(e) => {
    //                   e.preventDefault();
    //                   history.push({
    //                     pathname: "dashboard/edit",
    //                     state: {
    //                       id,
    //                       mode:
    //                         (isAdmin === "false" && value == 3) ||
    //                         (isAdmin === "true" && value == 2)
    //                           ? "edit"
    //                           : "view",
    //                     },
    //                   });
    //                 }}>
    //                 {(isAdmin === "false" && value == 3) ||
    //                 (isAdmin === "true" && value == 2) ? (
    //                   <i className="fas fa-edit"></i>
    //                 ) : (
    //                   <i className="fas fa-eye"></i>
    //                 )}
    //               </a>
    //             </p>
    //           </Tooltip>
    //           <Tooltip title="history">
    //             <p className="ml-3">
    //               <a
    //                 style={{ cursor: "pointer" }}
    //                 onClick={(e) => {
    //                   e.preventDefault();
    //                   setShowHistoryModal(true);
    //                   setHistoryId(id);
    //                 }}>
    //                 <i className="fas fa-history"></i>
    //               </a>
    //             </p>
    //           </Tooltip>
    //         </div>
    //       );
    //     },
    //   },
    // },
  ];

  const getCoeDropdown = async () => {
    let requestParams = {
      dropdownName: "allCoeCommonDropdown",
      //userId: getFromEncLocalStorage("userId"), //UserId
      searchText: 2,
    };
    const res = await APICall(
      urls.getCommonDropdownData,
      requestParams,
      "POST",
    );
    if (res.data !== null && res.data.length > 0) {
      setCoeOptions(res.data);
    } else {
      notify(1, "no coe data found");
    }
  };

  const getAggregateDropdown = async () => {
    let requestParams = {
      dropdownName: "aggregateDropdown",
    };
    const res = await APICall(
      urls.getCommonDropdownData,
      requestParams,
      "POST",
    );

    if (res.data !== null && res.data.length > 0) {
      setAggregateOptions(res.data);
    } else {
      notify(1, "no aggreagate data found");
    }
  };

  const getPlatformDropdown = async () => {
    let requestParams = {
      dropdownName: "platformDropdown",
    };
    const res = await APICall(
      urls.getCommonDropdownData,
      requestParams,
      "POST",
    );

    if (res.data !== null && res.data.length > 0) {
      setPlatformOptions(res.data);
    } else {
      notify(1, "no platform data found");
    }
  };

  const getStatusDropdown = async () => {
    let requestParams = {
      dropdownName: "status",
    };
    const res = await APICall(
      urls.getCommonDropdownData,
      requestParams,
      "POST",
    );

    if (res.data !== null && res.data.length > 0) {
      setStatusOptions(res.data);
    } else {
      notify(1, "no status data found");
    }
  };

  const getUserNames = async (e, callback) => {
    if (e.length > 3) {
      let requestParams = {
        dropdownName: "getAllUsers",
        searchText: e,
      };
      const res = await APICall(
        urls.getCommonDropdownData,
        requestParams,
        "POST",
      );
      if (res && res.data.length > 0) {
        let options = await res.data;
        // options = await options.map((ele) => ({
        //   label: ele.UserName,
        //   value: ele.UserId,
        //   EmailId: ele.EmailId,
        // }));

        await callback(options);
      }
    }
  };

  useEffect(() => {
    getCoeDropdown();
    getAggregateDropdown();
    getPlatformDropdown();
    getStatusDropdown();
  }, []);

  const resetFilter = async () => {
    setSelectedCoe([]);
    setSelectedAggregate([]);
    setSelectedPlatform([]);
    setSelectedStatus([]);
    setFromDate(CommonServices.getCurrentMonthStart());
    setToDate(CommonServices.getCurrentMonthEnd());
    setKeywords("");
    setSelectedUser([]);
    setSortColumn("");
    setSortDirection("");
    setStart(0);
    setCount(0);
  };

  const onClickFunction = async (event, name) => {
    if (name === "Submit") {
      let isEmptyReqObj = false;
      let reqFilterObj = {
        coe:
          selectedCoe && selectedCoe.length > 0
            ? selectedCoe.map(({ value }) => value).toString()
            : "",
        aggregate:
          selectedAggregate && selectedAggregate.length > 0
            ? selectedAggregate.map(({ value }) => value).toString()
            : "",
        platform:
          selectedPlatform && selectedPlatform.length > 0
            ? selectedPlatform.map(({ value }) => value).toString()
            : "",
        status:
          selectedStatus && selectedStatus.length > 0
            ? selectedStatus.map(({ value }) => value).toString()
            : "",
        fromDate:
          fromDate === null || fromDate === ""
            ? null
            : moment(fromDate).format("YYYY-MM-DD"),
        toDate:
          toDate === null || toDate === ""
            ? null
            : moment(toDate).format("YYYY-MM-DD"),
        keywords: keywords,
        user:
          selectedUser && selectedUser.length > 0
            ? selectedUser.map(({ value }) => value).toString()
            : "",
      };
      isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
        if (f === "" || f === null || f === undefined) {
          return true;
        } else {
          return false;
        }
      });
      if (isEmptyReqObj) {
        notify(1, "select atleast one filter");
      } else if (moment(fromDate).isAfter(moment(toDate))) {
        notify(1, "From Date should be less than To Date");
      } else if (fromDate && !toDate) {
        notify(1, "Select To Date");
      } else if (toDate && !fromDate) {
        notify(1, "Select From Date");
      } else {
        getDashboardData(false);
      }
    } else if (name === "Reset") {
      resetFilter();
      setReset(!reset);
    }
  };

  return (
    <>
      <Main active={"request"} removeContainer={true}>
        <Loadspinner
          filename="Report.js"
          isLoading={loading}
          isMiddle="false"
        />
        <div className="eventGallery">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "15px" }}>Mkisan Feed Report</h4>
              </div>
              <div className="col-md-4"></div>

              <div className="col-md-4" style={{ padding: "0% 3% 0% 0%" }}>
                <div
                  className="float-right col-sm-offset-2"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <button
                    className="btn btn-export"
                    style={{ marginLeft: 5 }}
                    onClick={() => {
                      if (count === 0) {
                        notify(1, "no data to download");
                      } else {
                        exportToExcelFunction();
                      }
                    }}
                  >
                    Export To Excel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix"></div>

        <div className="row mx-3">
          <div className="col-lg-12">
            <div className="filter-content pt-2" style={{ display: "" }}>
              <div className="row">
                <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">COE</label>
                    <SelectForm
                      options={coeOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={selectedCoe}
                      onChange={(event) => setSelectedCoe(event)}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    {/* <p style={{ color: "red" }}>
                          {formErrors["coE_isEmpty"]}
                        </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">Aggregate</label>
                    <SelectForm
                      options={aggregateOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={selectedAggregate}
                      onChange={(event) => setSelectedAggregate(event)}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    {/* <p style={{ color: "red" }}>
                          {formErrors["coE_isEmpty"]}
                        </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">Platform</label>
                    <SelectForm
                      options={platformOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={selectedPlatform}
                      onChange={(event) => setSelectedPlatform(event)}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    {/* <p style={{ color: "red" }}>
                          {formErrors["coE_isEmpty"]}
                        </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">Status</label>
                    <SelectForm
                      options={statusOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={selectedStatus}
                      onChange={(event) => setSelectedStatus(event)}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    {/* <p style={{ color: "red" }}>
                          {formErrors["coE_isEmpty"]}
                        </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">From Date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label=" "
                        style={{ marginTop: "5px" }}
                        value={fromDate}
                        onChange={(e) => setFromDate(e)}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField
                            style={{
                              backgroundColor: "white",
                              display: "flex",
                            }}
                            size="small"
                            {...params}
                            error={false}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                    {/* <p style={{ color: "red" }}>
                          {formErrors["EventFromDate_isEmpty"]}
                        </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">To Date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label=" "
                        style={{ marginTop: "5px" }}
                        value={toDate}
                        onChange={(e) => setToDate(e)}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField
                            style={{
                              backgroundColor: "white",
                              display: "flex",
                            }}
                            size="small"
                            {...params}
                            error={false}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                    {/* <p style={{ color: "red" }}>
                          {formErrors["EventFromDate_isEmpty"]}
                        </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">Keywords</label>
                    <InputForm
                      className=""
                      placeholder={""}
                      isDisabled={false}
                      textArea={false}
                      value={keywords}
                      onChange={(e) => setKeywords(e.target.value)}
                    />
                    {/* <p style={{ color: "red" }}>
                          {formErrors["kmiId_isEmpty"]}
                        </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">User</label>
                    <SelectForm
                      async
                      isSearchable
                      options={(e, callback) => getUserNames(e, callback)}
                      placeholder="Search User"
                      isDisabled={false}
                      value={selectedUser}
                      onChange={(event) => {
                        setSelectedUser(event);
                      }}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="float-right">
                    {/* <button
                      className="btn btn-submit"
                      style={{ marginLeft: 5 }}
                      onClick={(e) => onClickFunction(e, "Submit")}>
                      Apply
                    </button> */}
                    <SubmitButton
                      title="Apply"
                      onClick={(e) => onClickFunction(e, "Submit")}
                    />
                    {/* <button
                      className="btn btn-info"
                      style={{ marginLeft: 5 }}
                      onClick={(e) => onClickFunction(e, "Reset")}>
                      Reset
                    </button> */}
                    <ResetButton onClick={(e) => onClickFunction(e, "Reset")} />
                    {/* <button
                      className="btn btn-cancel"
                      style={{ marginLeft: 5 }}
                      onClick={(e) => onClickFunction(e, "Cancel")}>
                      Cancel
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12">
          <DynamicGrid
            options={options}
            data={dashboardData}
            columns={dashboardColumns}
          />
        </div>
      </Main>
    </>
  );
};

export default Report;
